import { SnowplowService } from 'wanderu-service-analytics';

function clicked({
    navType, action, selectedCurrency, unselectedCurrency,
}) {
    let property = {
        nav_type: navType,
        selected_currency: selectedCurrency,
    };

    if (unselectedCurrency) {
        property = {
            ...property,
            unselected_currency: unselectedCurrency,
        };
    }
    SnowplowService.fireStructuredEvent({
        category: 'navigation',
        action,
        label: 'currency',
        property,
    });
}

export default {
    clicked,
};
